import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const CodingIcon = ({ color, fillOpacity, ...props }) => (
  <svg{...helpers.getSvgDimensionsProps(props)} {...props}>
    <path d="M5.50821 12.8276L0 9.82365V8.15984L5.50821 5.17285V7.1271L1.67 8.97089L5.50821 10.8842V12.8276Z" fill={color} fillOpacity={fillOpacity} />
    <path d="M6.44946 13.879L10.1023 4.12085H11.2563L7.595 13.879H6.44946Z" fill={color} fillOpacity={fillOpacity} />
    <path d="M12.4915 12.8277V10.8843L16.3289 8.98641L12.4915 7.1032V5.17212L17.9997 8.16298V9.81676L12.4915 12.8277Z" fill={color} fillOpacity={fillOpacity} />
  </svg>
);

CodingIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

CodingIcon.defaultProps = {
  fillOpacity: 1,
  ...helpers.getDefaultIconDimensionsProps(18, 18),
};

export default CodingIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/coding.js